import React, { useState, useEffect } from "react";
import logo from "../asset/logo-main.png";
import axios from "axios";
import RazorPay from "./RazorPay";
import { useNavigate } from "react-router-dom";
import AppliedAndAllottedTable from "./AppliedAndAllottedTable";
import SgbCancelModel from "./appliedandallottedsgb/SgbCancelModel";
import swal from "sweetalert2";
import MsgDisplay from "./MsgDisplay";

const SgbDetails = () => {
  const navigate = useNavigate();
  const clientCode = JSON.parse(localStorage.getItem("clientCode"));
  const token = JSON.parse(localStorage.getItem("token"));
  const [applyNowActive, setApplyNowActive] = useState("");
  const [confirmOrderActive, setConfirmOrderActive] = useState("");
  const [tradeDetailsActive, setTradeDetailsActive] = useState(false);
  const [confirmCancellationActive, setConfirmCancellationActive] =
    useState(false);
  const [cancelOrderActive, setCancelOrderActive] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [qty, setQty] = useState(1);
  const [amount, setAmount] = useState("Enter a valid amount");
  const [clientDetails, setClientDetails] = useState([]);
  const [selectedMaxQuantity, setSelectedMaxQuantity] = useState("");
  const [orderResponse, setOrderResponse] = useState({});
  const [appliedSgbData, setAppliedSgbData] = useState();
  const [cancelModalFlag, setCancelModalFlag] = useState();
  const [cancelModalData, setCancelModalData] = useState(null);
  const [showRazorPay, setShowRazorPay] = useState(false);
  const [filter, setFilter] = useState("ALL");
  const [applied_alloted_filter, setApplied_alloted_filter] = useState("ALL");
  const [isordersuccess, setIsordersuccess] = useState();
  const [bank_details, setBank_details] = useState();
  const [selectedBank, setSelectedBank] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [orderData, setOrderData] = useState({
    exchange: "NSE",
    symbol: "",
    order_no: "",
    price: "",
    quantity: "",
    physical_dematflag: "D",
    client_code: "",
    pan: "",
    depository: "",
    dpID: "",
    client_BenId: "",
    name: "",
    email: "",
    mobilNo: "",
    client_RefNo: "",
    activity_type: "ER",
  });

  const handlebankSelect = (index) => {
    debugger;
    setSelectedBank(bank_details[index]);
  };

  const handleMaxQtyChange = (event) => {
    setSelectedMaxQuantity(event.target.value);
  };

  const handleFilterValue = (e) => {
    setFilter(e.target.value);
    fetchData(
      "SGB/SgbData",
      setData,
      { pflag: e.target.value },
      process.env.REACT_APP_APIURL
    );
  };

  const handle_Applied_Alloted_FilterValue = (e) => {
    setApplied_alloted_filter(e.target.value);
    fetchData(
      "SGB/SgbDataAppliedAllotted",
      setAppliedSgbData,
      { pflag: e.target.value },
      process.env.REACT_APP_APIURL
    );
  };

  //apply buttonin the table
  const handleApplyNowClick = (item) => {
    debugger;
    setSelectedItem(item);
    setAmount(` ₹${item.MINPRICE * qty}`);
    setApplyNowActive("active");
  };

  const handleClosePopup = () => {
    debugger;
    setApplyNowActive("");
    setConfirmOrderActive("");
    const integerValue = parseInt(1);
    setQty(String(integerValue));
    setAmount(` ₹${selectedItem.MINPRICE * integerValue}`);
    window.location.reload();

    // setQty(1);
    // setAmount("Enter a valid quantity");
  };

  //apply for specific sgb
  const handleApplyOrder = (amount, quantity) => {
    debugger;
    if (quantity == "") {
      setConfirmOrderActive("");
      new swal({
        title: "Error",
        text: "Please enter a quantity",
        icon: "error",
        button: "OK",
      });
    } else if (qty < 1 || qty > 500) {
      debugger;
      new swal({
        title: "Error",
        text: "Please enter a quantity between 1 and 500",
        icon: "error",
        button: "OK",
      });
    } else {
      let amount_val_array = amount.split(":");
      let amount_value = amount_val_array[1];
      let amount_val = amount_value.split("₹")[1];
      //console.log(amount_val, quantity);
      setConfirmOrderActive("active");
      setApplyNowActive("");
    }
  };

  const handleTradeDetailsClick = () => {
    setTradeDetailsActive(true);
    setConfirmOrderActive(false);
  };

  const handleCancelClick = () => {
    setConfirmCancellationActive(true);
  };

  const handleCancelOrderClick = () => {
    setCancelOrderActive(true);
    setConfirmCancellationActive(false);
  };

  const handlelogout = () => {
    navigate("/");
  };

  const handleQtyChange = (event) => {
    debugger;
    const value = event.target.value;

    if (value) {
      const integerValue = parseInt(value);
      setQty(String(integerValue));
      setAmount(` ₹${selectedItem.MINPRICE * integerValue}`);
    } else {
      setQty("");
      setAmount("Enter a valid quantity");
    }

    //   if (integerValue >= 1 && integerValue <= 500) {
    //     debugger;
    //     setQty(String(integerValue));
    //     setAmount(` ₹${selectedItem.MINPRICE * integerValue}`);
    //   } else {
    //     debugger;
    //     setQty("");
    //     setAmount("Enter a valid quantity");
    //     new swal({
    //       title: "Error",
    //       text: "Please enter a quantity between 1 and 500",
    //       icon: "error",
    //       button: "OK",
    //     });
    //   }
  };

  const handleSubmitOrder = (amount, qty, series, lastdate, rate) => {
    debugger;
    let amount_val_array = amount.split(":");
    let amount_value = amount_val_array[1];
    let amount_val = amount_value.split("₹")[1];

    setOrderData({
      ...orderData,
      symbol: selectedItem.SYMBOL,
      price: amount_val,
      issueprice: selectedItem.MINPRICE,
      quantity: qty,
      client_code: clientCode,
      pan: clientDetails[0]["PAN"],
      depository: clientDetails[0].depository,
      dpID: clientDetails[0].dpId,
      client_BenId: clientDetails[0].clientBenId,
      name: clientDetails[0].clientname,
      email: clientDetails[0].emailid,
      mobilNo: clientDetails[0].mobileno,
    });

    setShowRazorPay(true);
    setApplyNowActive("");
    setConfirmOrderActive("");
    const integerValue = parseInt(1);
    setQty(String(integerValue));
    setAmount(` ₹${selectedItem.MINPRICE * integerValue}`);

    debugger;
  };

  const fetchData = async (apiEndpoint, setDataFunction, data, url) => {
    debugger;
    $("#CRloader").show();
    try {
      const response = await axios.post(`${url}${apiEndpoint}`, data, {
        headers: {
          "Content-Type": "application/json",
          token: token,
          clientcode: clientCode,
          applicationname: "SGB",
        },
      });

      let newData = await response.data;
      if (newData.Table1) {
        newData = await response.data.Table1;
      }
      debugger;
      //console.log(newData);
      $("#CRloader").hide();
      setDataFunction(newData);
    } catch (error) {
      setErrorMsg(error.response.statusText);
      console.log(error.response.statusText);
    }
  };

  useEffect(() => {
    const display_sgb_data = async () => {
      fetchData(
        "SGB/SgbData",
        setData,
        { pflag: filter },
        process.env.REACT_APP_APIURL
      );
    };
    display_sgb_data();
    //console.log("data", data);
    const get_bank_details = async () => {
      fetchData(
        "RazorPay/Get_bank_details",
        setBank_details,
        { clientcode: clientCode },
        process.env.REACT_APP_APIURL
      );
    };
    get_bank_details();

    const appliedAllotedSGBGetData = async () => {
      debugger;
      fetchData(
        "SGB/SgbDataAppliedAllotted",
        setAppliedSgbData,
        { pflag: filter, pUSERID: clientCode },
        process.env.REACT_APP_APIURL
      );
    };
    appliedAllotedSGBGetData();

    const getClientDetails = async () => {
      debugger;
      fetchData(
        "Client/ClientData",
        setClientDetails,
        {
          clientcode: clientCode,
        },
        process.env.REACT_APP_LOGINPAGE
      );
    };
    getClientDetails();
  }, [isordersuccess]);

  //console.log("reponseAllotedData", appliedSgbData);
  ////console.log("DETAILS", clientDetails[0].clientname);

  return (
    <div>
      <div id="CRloader" class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="header">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-xs-12">
              <div class="logo_pl">
                <a>
                  <img src={logo} alt="logo" />
                </a>
              </div>
            </div>
            <div class="col-lg-6 col-xs-12" align="right">
              <div class="log_out_btn">
                <div class="group_btn">
                  <div class="code_name">
                    {clientDetails[0] && clientDetails[0].clientname}
                  </div>
                  <div class="log_b">
                    <button type="button" id="logout" onClick={handlelogout}>
                      <i class="fa fa-user"></i>Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>{errorMsg && <MsgDisplay msg={errorMsg} />}</div>
      <div class="sec">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-xs-12">
              <h3 className="text-4xl font-[500] mb-[10px]">
                Sovereign Gold Bond
              </h3>
              <ul class="tab_view">
                <li class="active">
                  <a data-toggle="pill" href="#home">
                    On-going
                  </a>
                </li>
                <li>
                  <a data-toggle="pill" href="#menu1">
                    Applied & Allotted SGBs
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="tab-content">
            <div id="home" class="tab-pane fade in active">
              <div class="row">
                <div class="col-lg-3 col-xs-12">
                  <div class="filed_cl">
                    {/* <label>Status</label> */}
                    {/* <select
                      className="form_class"
                      value={filter}
                      onChange={handleFilterValue}
                    >
                      <option value="ALL">ALL</option>
                      <option value="On-going">On-going</option>
                      <option value="Forthcoming">Forthcoming</option>
                    </select> */}
                  </div>
                </div>
                <div class="col-lg-6 col-xs-12"></div>
                <div class="col-lg-3 col-xs-12">
                  <div class="filed_cl">
                    <label>Search</label>
                    <input
                      type="text"
                      placeholder="Search"
                      class="form_class"
                      name=""
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-xs-12">
                  <div class="scroll_data">
                    <table class="tbl_web">
                      <thead>
                        <tr>
                          <th>SGB Name</th>
                          <th>Open Date</th>
                          <th>Close Date</th>
                          <th>Interest till Maturity (per annum)</th>
                          {/* <th>Maturity Date</th> */}
                          <th>Status</th>
                          <th>Apply</th>
                        </tr>
                      </thead>
                      <tbody class="tbl_body">
                        {data.map((item, index) => (
                          <tr key={index}>
                            <td id="symbolname">{item.NAME}</td>
                            <td id="opendate">{item.BIDDINGSTARTDATE}</td>
                            <td id="closedate">{item.BIDDINGENDDATE}</td>
                            <td id="interset">
                              {(
                                item.MINPRICE *
                                (item.INTERESTRATE / 100)
                              ).toFixed(3)}
                              /gm
                            </td>
                            {/* <td id="maturitydate"></td> */}
                            <td>
                              {item.PFLAG === "O"
                                ? "ONGOING"
                                : item.PFLAG === "U"
                                ? "UPCOMING"
                                : "EXPIRED"}{" "}
                            </td>
                            <td align="center">
                              {item.APPLYFLAG !== "N" ? (
                                <button
                                  className="apply_btn click_pop"
                                  onClick={() => handleApplyNowClick(item)}
                                >
                                  Apply
                                </button>
                              ) : (
                                item.CLOSEFLAG === "Y" && (
                                  <button className="apply_btn" disabled>
                                    Close
                                  </button>
                                )
                              )}
                              {/* {item.APPLYFLAG != "N" && (
                                <button
                                  className="apply_btn click_pop"
                                  onClick={() => handleApplyNowClick(item)}
                                >
                                  Apply
                                </button>
                              )} */}
                            </td>
                          </tr>
                        ))}
                        {/* {!errorMsg ? (
                        {}  

                        ) : (
                          <MsgDisplay msg={errorMsg} />
                        )} */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {selectedItem && (
                <div>
                  <div class={"pop_section" + applyNowActive} id="apply_now">
                    <div class="pop_inner">
                      <button
                        class="close_add click_1"
                        onClick={handleClosePopup}
                      >
                        X
                      </button>

                      <h3>{selectedItem.NAME}</h3>
                      {/* <p>
                        <b>Min Qty: </b> {selectedItem.MINBIDQUANTITY} gm{" "}
                        <b>&nbsp;&nbsp;&nbsp;&nbsp; Max Qty:</b>
                        {" 500 grams/year"}
                      </p> */}
                      <p>
                        <b id="series">Series: </b> {selectedItem.SERIES}
                      </p>
                      <p>
                        <b>Rate: </b> ₹{selectedItem.MINPRICE}
                      </p>
                      <div class="tx_div">
                        <b>QTY(in gms): </b>
                        <input
                          id="qty"
                          class="qty"
                          type="text"
                          name=""
                          value={qty}
                          onChange={handleQtyChange}
                        />
                      </div>
                      <p id="amount">
                        <b>Amount: </b> <span id="amount">{amount}</span>
                      </p>
                      <p>
                        <b>Last Date: </b> {selectedItem.BIDDINGENDDATE}
                      </p>
                      <p>
                        <b>Interest received per annum: </b> ₹
                        {(
                          selectedItem.MINPRICE *
                          (selectedItem.INTERESTRATE / 100)
                        ).toFixed(3)}
                        /gm
                        <b>({selectedItem.INTERESTRATE}% of the issue price)</b>
                      </p>
                      <p>
                        <b>Interest received Interval: </b> Half Yearly
                      </p>
                      {/* <p>
                        <b>Issue Price: </b> {selectedItem.MINPRICE}/gm
                      </p> */}
                      <div class="row">
                        <div class="col-lg-12 col-xs-12">
                          <div class="scroll_data">
                            {bank_details && (
                              <table class="tbl_web">
                                <thead>
                                  <tr>
                                    <th>Select</th>
                                    <th>Bank Name</th>
                                    <th>Account Number</th>
                                    <th>IFSC</th>
                                    <th>UPID</th>
                                  </tr>
                                </thead>
                                <tbody class="tbl_body">
                                  {bank_details.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <input
                                          type="radio"
                                          name="selectRow"
                                          value={index}
                                          onChange={() =>
                                            handlebankSelect(index)
                                          }
                                          checked={selectedBank === item}
                                        />
                                      </td>
                                      <td>{item.BKNAME}</td>
                                      <td>{item.BKACNO}</td>
                                      <td>{item.IFSC}</td>
                                      <td>{item.CUPIID}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-xs-12">
                          {selectedBank && bank_details && (
                            <button
                              class="apply_now click_confirm_order"
                              onClick={() =>
                                handleApplyOrder(
                                  document.getElementById("amount").textContent,
                                  qty
                                )
                              }
                            >
                              Apply
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {selectedBank && (
                    <div>
                      <h2>Selected Row Details:</h2>
                      <p>Bank Name: {selectedBank.BKNAME}</p>
                      <p>Account Number: {selectedBank.BKACNO}</p>
                      <p>IFSC: {selectedBank.IFSC}</p>
                      <p>UPID: {selectedBank.CUPIID}</p>
                    </div>
                  )} */}
                  {selectedBank && bank_details ? (
                    <div
                      class={"pop_section" + confirmOrderActive}
                      id="confirm_order"
                    >
                      <div class="pop_inner">
                        <button
                          class="close_add click_2"
                          onClick={handleClosePopup}
                        >
                          X
                        </button>
                        <h3>Confirm Order</h3>
                        <p>
                          <b class="bolder">Series: </b>
                          <span id="series">{selectedItem.SERIES}</span>
                        </p>
                        <p>
                          <b>Rate: </b> ₹
                          <span id="rate">{selectedItem.MINPRICE}</span>
                        </p>
                        <p>
                          <b>QTY: </b>
                          {qty}
                        </p>
                        <p>
                          <b>Amount: </b>
                          <span id="amount">{selectedItem.MINPRICE * qty}</span>
                        </p>
                        <p>
                          <b>Last Date: </b>
                          <span id="lastdate">
                            {selectedItem.BIDDINGENDDATE}
                          </span>
                        </p>
                        <p>
                          <b>Interest received till Maturity: </b> ₹
                          {(
                            selectedItem.MINPRICE *
                            (selectedItem.INTERESTRATE / 100)
                          ).toFixed(3)}
                          /gm
                          <b>
                            ({selectedItem.INTERESTRATE}% of the issue price)
                          </b>
                        </p>
                        <p>
                          <b>Interest received Interval: </b>ANNUALLY
                        </p>
                        <p>
                          <b>Issue Price: </b>
                          {selectedItem.MINPRICE}/gm
                        </p>
                        <p>
                          <b>Bank Name: </b>
                          {selectedBank.BKNAME}
                        </p>
                        <p>
                          <b>Account Number: </b>
                          {selectedBank.BKACNO}
                        </p>
                        <p>
                          <b>IFSC: </b>
                          {selectedBank.IFSC}
                        </p>

                        <div>
                          {showRazorPay && orderData && selectedBank && (
                            <RazorPay
                              order_data={orderData}
                              setIsordersuccess={setIsordersuccess}
                              bank_details={selectedBank}
                            />
                          )}
                          {!showRazorPay && (
                            <button
                              class="apply_now click_trade_details"
                              onClick={() =>
                                handleSubmitOrder(
                                  document.getElementById("amount").textContent,
                                  qty,
                                  document.getElementById("series").textContent,
                                  document.getElementById("lastdate")
                                    .textContent,
                                  document.getElementById("rate").textContent
                                )
                              }
                            >
                              Submit
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <MsgDisplay />
                  )}
                </div>
              )}
            </div>
            <div id="menu1" class="tab-pane fade">
              <div class="row">
                <div class="col-lg-3 col-xs-12">
                  <div class="filed_cl">
                    <label>Status</label>
                    <select
                      className="form_class"
                      value={applied_alloted_filter}
                      onChange={handle_Applied_Alloted_FilterValue}
                    >
                      <option value="ALL">ALL</option>
                      <option value="Applied">Applied</option>
                      <option value="Allotted">Allotted</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 col-xs-12"></div>
                <div class="col-lg-3 col-xs-12">
                  <div class="filed_cl">
                    <label>Search</label>
                    <input
                      type="text"
                      placeholder="Search"
                      class="form_class"
                      name=""
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <AppliedAndAllottedTable
                  appliedSgbData={appliedSgbData}
                  setCancelModalFlag={setCancelModalFlag}
                  setCancelModalData={setCancelModalData}
                  errormsg={errorMsg}
                />
                {cancelModalFlag === true && (
                  <SgbCancelModel
                    setCancelModalFlag={setCancelModalFlag}
                    cancelModalData={cancelModalData}
                    setCancelModalData={setCancelModalData}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SgbDetails;
